<app-alerts />

<app-admin-brand-banner-details-form
  (submitClickEvent)="handleSubmitClickEvent($event)" />
